<div class="product-container">
  <div class="avatar-container">
    <product-avatar [product]="product" class="product-avatar"></product-avatar>
    <product-categories [categories]="product.categories"></product-categories>
  </div>
  <div class="content-co">
    <div class="header-co">
      <div class="product-title">
        <product-title
          [title]="product.store_product_detail?.name || product.name"
        ></product-title>
        <price-label [value]="priceLabel | async"></price-label>
      </div>
      <product-header
        [product]="product"
        [showBackButton]="false"
      ></product-header>
    </div>
    <product-description [product]="product"></product-description>
    <product-kpi></product-kpi>
    <!-- <club-product-cashback></club-product-cashback> -->
    <payment-box
      [product]="product"
      (paymentBoxData)="handlePaymentBoxData($event)"
    ></payment-box>
  </div>
</div>
<note-box [countries]="product.show_countries"></note-box>
<product-expansion [product]="product"></product-expansion>
<related-products
  *ngIf="product.store_product_detail?.related_products?.length > 0"
  [list]="product.store_product_detail.related_products"
  [isDesktop]="true"
></related-products>
<app-faq model="product" [objectId]="product.id"></app-faq>
